import locations from "../../data/locations"
import {
  DevDocActionTypes,
  DevDocsState,
  SET_CHART_DATA,
  SET_DATE_TIME,
  SET_FACILITY_NAME,
  SET_FULL_YEAR_LOCATION_DATA,
  SET_LOCATIONS,
  SET_PARKING_AVAILABILITY_MODEL,
  SET_PARKING_AVAILABILITY_MODELS,
} from "./types"

export const initialState: DevDocsState = {
  dateTime: new Date(),
  facilityName: "Zug",
  parkingAvailabilityModel: undefined,
  locations: locations,
  parkingAvailabilityModels: [],
  chartData: [],
  fullYearLocationData: [],
}

export function devDocsReducer(
  state = initialState,
  action: DevDocActionTypes
): DevDocsState {
  switch (action.type) {
    case SET_DATE_TIME:
      return {
        ...state,
        dateTime: action.payload.dateTime,
      }
    case SET_FACILITY_NAME:
      return {
        ...state,
        facilityName: action.payload.facilityName,
      }
    case SET_PARKING_AVAILABILITY_MODEL:
      return {
        ...state,
        parkingAvailabilityModel: action.payload.parkingAvailabilityModel,
      }
    case SET_LOCATIONS:
      return {
        ...state,
        locations: action.payload.locations,
      }
    case SET_PARKING_AVAILABILITY_MODELS:
      return {
        ...state,
        parkingAvailabilityModels: action.payload.parkingAvailabilityModels,
      }
    case SET_CHART_DATA:
      return {
        ...state,
        chartData: action.payload.chartData,
      }
    case SET_FULL_YEAR_LOCATION_DATA:
      return {
        ...state,
        fullYearLocationData: action.payload.fullYearLocationData,
      }
    default:
      return state
  }
}
